import { isValid, parseISO } from 'date-fns';

import { formatMonthDayYear } from './date';

import type { UserContractEnd } from '@/types';

export const formatContractEndValue = (
  contractEnd?: UserContractEnd | null,
): string | null => {
  if (!contractEnd) return null;
  const status = contractEnd.status?.trim() || null;
  const displayStatus =
    status || (contractEnd.displayMode === 'ongoing' ? 'Ongoing' : null);

  if (!contractEnd.date) return displayStatus;

  const parsedDate = parseISO(contractEnd.date);
  const formattedDate = isValid(parsedDate)
    ? formatMonthDayYear(parsedDate)
    : null;

  if (!formattedDate) return displayStatus;
  if (!displayStatus) return formattedDate;

  return `${formattedDate} - ${displayStatus}`;
};

export const formatContractEndLabel = (
  contractEnd?: UserContractEnd | null,
): string | null => {
  const value = formatContractEndValue(contractEnd);
  if (!value) return null;

  return contractEnd?.displayMode === 'ongoing'
    ? `Engagement: ${value}`
    : `Contract End Date: ${value}`;
};

export const formatMemberContractEndLabel = (
  contractEnd?: UserContractEnd | null,
): string | null => {
  if (!contractEnd?.date) return null;

  const parsedDate = parseISO(contractEnd.date);
  if (!isValid(parsedDate)) return null;

  return `Contract End Date: ${formatMonthDayYear(parsedDate)}`;
};
